<template>
    <div  :class="deviceType == 'alipay' ? 'color-bg-huafu' : 'waitingBody'">
        <div class="waiting-box" :class="deviceType == 'alipay' ? 'huafu-card' : ''" >
          <div class="waiting-img" v-if="!type">

            <img src="../../assets/image/icon_waiting.png"  class="image"/>
          </div>

            <div class="wait" :class="deviceType == 'alipay' ? 'huafu-wait' : ''" v-show="!show">等待医生接诊中…</div>
            <div class="time" :class="deviceType == 'alipay' ? 'huafu-wait' : ''" v-show="!show">
                <span>正在排队，预计60秒，累计等待</span>
                <span :class="deviceType == 'alipay' ? 'color-huafu' : ''">{{ minute }}:</span>
                <span :class="deviceType == 'alipay' ? 'color-huafu' : ''">{{ second }}</span>
            </div>
            <div class="cancel-btn" @click="cancelOrder(6)">取消等待</div>
        </div>
        <div class="waiting-notice" :class="deviceType == 'alipay' ? 'huafu-text' : ''">
            <span class="ntTitle">注意事项</span>
            <span>
                1.如您有药物过敏史，您须提前填写清楚，或告知医生或医生团队，同时用药过程中如有不适反应要主动、积极告知平台、医生或医生团队。
            </span>
            <span>
                2、如果您在在线诊疗中或在线诊疗后，发现自身的症状和体征发生改变或恶化，或有明显的身体不适，请您立即告知医生，并及时就近急诊就医，以免贻误病情。
            </span>
        </div>
    </div>
</template>

<script>
import { showDialog, showToast } from 'vant'
import { mapGetters, mapMutations } from 'vuex'
// 公共方法
import { getUrlParams } from '../../utils/const'
import eventEmitter from '@/utils/bus'
import back from '@/utils/EventForAndroid'
export default {
  name: 'trtcCalling',
  data () {
    return {
      minute: '00',
      second: '00',
      timer: null,
      videoTimer: null,
      sentOrder: false,
      show: false,
      type: '',
      statusTimer: null,
      isCompleted: false,
      logined: false,
      isRuiZe: process.env.VUE_APP_RUIZE_CLIENT_ID // 是否是睿择
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'orderDetail', 'imInfo', 'urlParams', 'deviceType'])
  },
  watch: {
    minute: function (newVal, oldVal) {
      if (newVal === '05') {
        showDialog({
          message: '医生正在忙碌，请重新发起问诊，或稍后再试',
          confirmButtonText: '知道了',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true
        })
          .then(() => {
            this.cancelOrder(7)
            this.$router.replace({
              path: '/',
              query: {
                ...this.urlParams
              }
            })
          })
      }
    }
  },
  async created () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    await this.getUrlParams()
    await this.getOrderStatusInfo()
    this.statusTimer = setInterval(() => {
      this.getOrderStatusInfo()
    }, 3000)
    this.timer = null
    this.setWaitTime()
    eventEmitter.on('accept-success', this.acceptSuccess)
  },
  methods: {

    goBack () {
      const deviceType = this.deviceType || getUrlParams()['deviceType']
      if (deviceType === 'wechat') {
        wx.miniProgram.navigateBack({
          delta: history.length
        });
      } else if (deviceType === 'uniapp') {
        window.postMessage({
          data: {
            action: 'popstate'
          }
        }, '*')
        uni.postMessage({
          data: {
            action: 'popstate'
          }
        })
      } else {
        this.$router.back()
        back()
      }
    },
    // 取消等待
    cancelOrder (status) {
      let params = {
        orderID: this.orderDetail.orderID,
        inquiryStatus: status, // 5:医生取消 / 6:患者取消 / 7:超时
        cancelReason: ''
      }
      this.$_http.post(this.$_API.H5_INQUIRY_CENTER_CANCEL_WAIT, params).then(res => {
        if (res.success && res.data) {
          showToast('取消成功')
          clearInterval(this.statusTimer)
          // this.$router.replace({
          //     path: '/patientDetail',
          //     query: {
          //         ...this.urlParams,
          //     },
          // })
          this.goBack()
        } else {
          console.log('取消失败')
        }
      })
    },
    toPage () {
      clearInterval(this.statusTimer)
      clearInterval(this.timer)
      // 问诊状态(0:无 / 1:待派单 / 2:已派单待接诊 / 3:已接诊 / 4:接诊完成 / 5:医生取消 / 6:患者取消 / 7:超时 / ）
      if (this.orderDetail.inquiryStatus > 1 && this.orderDetail.inquiryStatus < 5) {
        if (this.orderDetail.inquiryStatus === 4) {
          this['global/updateStep'](3)
        } else {
          this['global/updateStep'](1)
        }
        if (this.orderDetail.inquiryType === 1) {
          this.$router.replace({
            path: '/consultation',
            query: {
              ...this.urlParams
            }
          })
        } else if (this.orderDetail.inquiryType === 2) {
          this.$router.replace({
            path: '/trtcCalling',
            query: {
              ...this.urlParams
            }
          })
        } else {
          this.$router.replace({
            path: '/videoPage',
            query: {
              ...this.urlParams
            }
          })
        }
      } else if (this.orderDetail.inquiryStatus >= 5) {
        showDialog({
          message: '问诊已取消，请退出后重新发起问诊',
          confirmButtonText: '知道了',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true
        })
          .then(() => {
            if (this.userInfo.clientID === this.isRuiZe) {
              window.history.go(-1)
            } else {
              this.$router.replace({
                path: '/',
                query: {
                  ...this.urlParams
                }
              })
            }
          })
      }
    },
    async getOrderStatusInfo () {
      if (!this.urlParams.orderID) {
        return false
      }
      let params = {
        orderID: this.urlParams.orderID
      }
      await this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_ORDER_STATUS, { params }).then(res => {
        if (res.success && res.data.doctorIMID) {
          this['user/updateOrderDetail']({
            ...this.orderDetail,
            ...res.data,
            doctorID: res.data.doctorIMID,
            userSig: res.data.patientUserSig
          })
          if (!this.userInfo.patientInfo) {
            this['user/updateUserInfo']({ ...this.userInfo, patientInfo: { patientName: res.data.patientName } })
          }
          this.toPage()
        }
      })
    },
    acceptSuccess (e) {
      this['user/updateOrderDetail']({ ...this.orderDetail, roomID: e.roomID })
    },
    // 设置等待时间
    setWaitTime () {
      let second = 0
      let minute = 0
      let hour = 0
      this.timer = setInterval(() => {
        second++
        if (second === 60) {
          second = 0
          minute += 1
        }
        if (minute === 60) {
          minute = 0
          hour += 1
        }
        this.hour = this.addZero(hour)
        this.minute = this.addZero(minute)
        this.second = this.addZero(second)
      }, 1000)
    },
    addZero (num) {
      return Number(num) < 10 ? '0' + num : num
    },
    getUrlParams () {
      if (this.$route.name === 'rpViewer') return
      let obj = this.$route.query
      this.type = obj.type
      if (!obj['orderID'] || !obj['token']) {
        showDialog({
          message: '参数缺失，请重新进入',
          confirmButtonText: '确定',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true
        })
      }
      this['global/updateUrlParams'](obj)
    },
    ...mapMutations(['user/updateOrderDetail', 'global/updateUrlParams', 'global/updateStep', 'user/updateUserInfo'])
  },
  unmounted () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.statusTimer) {
      clearInterval(this.statusTimer)
    }
    this.timer = null
    this.statusTimer = null
  }
}
</script>

<style scoped lang="scss">
.waitingBody {
  height: 100vh;
  overflow-y: auto;
  flex-direction: column;
  display: flex;
   justify-content: center;
   align-items: center;
}

.waiting-box {
  flex-shrink: 0;
  flex-grow: 1;
  width: 100%;
  padding-bottom: 5px;
  flex-direction: column;
    display: flex;
  align-items: center;
  justify-content: center;
    background: linear-gradient(135deg, var(--order-primary, #438bef), var(--order-primary, #498ce9), var(--order-primary, #438bef));
    border-radius: 8px;
}

.waiting-img {
    width: 100%;
     display: flex;
  justify-content: center;
  align-items: center;
}
.image{
  width: 100px;
  height: 100px;
}

.wait {
    text-align: center;
    color: #fff;
    font-size: 22px;
}

.time {
    text-align: center;
    color: #fff;
  font-size: 14px;
    margin-top: 15px;
   margin-bottom: 15px;
}

.cancel-btn {
    border-radius: 18px;
    padding: 6px 0;
    margin: 0 auto;
    width: 104px;
    color: #ffffff;
    font-size: 14px;
    border: 1px solid #ffffff;
    text-align: center;
}

.waiting-notice {
  padding-top: 3px;
   padding-right: 3%;
  padding-left: 3%;
    font-size: 15px;
    color: #8c8c8c;
   display: flex;
  justify-content: center;
 align-items: center;
  flex-direction: column;
}
.ntTitle{
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.huafu-text {
    color: #fff
}

.huafu-card {
    background: #fff !important;
}

.huafu-wait {
    color: #000 !important
}

@media (max-height: 610px) {
  .wait{
    font-size: 13px;
  }
  .time{
    margin-top: 3px;
    margin-bottom: 3px;
    font-size: 12px;
  }
  .waiting-notice {
    font-size: 10px;
  }

  .cancel-btn {
    padding: 3px 0;
    font-size: 12px;

  }

  .waiting-img {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image{
    width: 50px;
    height: 50px;
  }

}
</style>
